import { render, staticRenderFns } from "./CurriculumVitaeInfo.vue?vue&type=template&id=3369b1b4&"
import script from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeInfo.vue?vue&type=style&index=0&id=3369b1b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports